export default __webpack_public_path__ + "static/media/navbar-approved-templates-dark.6e746c26.svg";